import baseStyled, { ThemedStyledInterface } from 'styled-components';
import { Theme } from './themes';

const styled: ThemedStyledInterface<Theme> = baseStyled as any;
export default styled
